import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import PickupPromotionBanner from '@tcp/core/src/components/common/molecules/PickupPromotionBanner';
import BopisPromotionBanner from '@tcp/core/src/components/common/molecules/PickupBopisPromotionBanner';
import EddComponent from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent';
import CARTPAGE_CONSTANTS from '@tcp/core/src/components/features/CnC/CartItemTile/CartItemTile.constants';
import ButtonSpinner from '@tcp/core/src/components/common/atoms/ButtonSpinner';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import { isCanada } from '@tcp/core/src/utils';
import BodyCopy from '../../atoms/BodyCopy';
import styles from '../DeliveryMethods/styles/DeliveryMethods.style';
import withStyles from '../../hoc/withStyles';
import { checkForFreeShipping } from '../../../features/CnC/BagPage/views/Bagpage.utils';
import FreeShippingMessage from '../FreeShippingMessage';

const EddWrapper = ({
  selectedShipmentCode,
  newBag,
  isPDP,
  isQuickView,
  freeShippingThershold,
  shipments,
  subheading,
  shippingTotal,
  isDynamicFreeShippingEnabled,
  orderType,
  productTotal,
}) => {
  const subTitleValue = checkForFreeShipping({
    isPDP,
    isQuickView,
    selectedShipmentCode,
    shipments,
    freeShippingThershold,
    shippingTotal,
    isDynamicFreeShippingEnabled,
    orderType,
    productTotal,
  })
    ? subheading
    : '';
  return (
    <EddComponent
      selectedShipment={selectedShipmentCode}
      fulfillmentGroup
      myBagSpc
      isRangeDate
      fontSize="fs12"
      subtitle={subTitleValue}
      newBag={newBag}
      isPDP={isPDP}
      isQuickView={isQuickView}
    />
  );
};

const getClassName = (subheading) => {
  return `sub-header-pickup ${subheading === 'Free shipping' ? 'text-Capitalize' : ''}${
    subheading === 'Unavailable' || subheading === 'lbl_unavlbl' ? 'unavailable-sub-header' : ''
  }`;
};

const getFontWeight = (isPickUpSelected, checkForOOSForVariant, fulfillmentGroup) => {
  return (isPickUpSelected && !checkForOOSForVariant) || fulfillmentGroup ? 'extrabold' : 'regular';
};

const isEnterKey = (e) => {
  return e.keyCode === 13;
};

const pickupUpdate = ({
  param,
  isDisableButton,
  fulfillmentGroup,
  isPickUpSelected,
  value,
  pickupSelectionUpdate,
  fromStoreSpecial,
}) => {
  if (fromStoreSpecial) {
    if (isDisableButton || fulfillmentGroup) {
      const effectiveValue = typeof param === 'string' ? param : value;
      return pickupSelectionUpdate(effectiveValue);
    }
  } else if (isDisableButton || (fulfillmentGroup && isPickUpSelected)) {
    return null;
  }
  const effectiveValue = typeof param === 'string' ? param : value;
  return pickupSelectionUpdate(effectiveValue);
};

const renderFreeShippingMessage = ({
  value,
  freeShippingThreshold,
  isDynamicFreeShippingEnabled,
  freeShipsMsg,
  isFreeShippingOnFulfillmentTileEnabled,
}) => {
  return isDynamicFreeShippingEnabled &&
    value === 'home' &&
    isFreeShippingOnFulfillmentTileEnabled ? (
    <FreeShippingMessage threshold={freeShippingThreshold} freeShipsMsg={freeShipsMsg} className />
  ) : null;
};

const handleClick = ({
  param,
  isBopisMultipleStoreEnabled,
  isBossMultipleStoreEnabled,
  shouldShowSizeError,
  displayErrorMessage,
  isDisableButton,
  fulfillmentGroup,
  isPickUpSelected,
  value,
  pickupSelectionUpdate,
  fromStoreSpecial,
}) => {
  pickupUpdate({
    param,
    isDisableButton,
    fulfillmentGroup,
    isPickUpSelected,
    value,
    pickupSelectionUpdate,
    fromStoreSpecial,
  });

  if ((isBopisMultipleStoreEnabled || isBossMultipleStoreEnabled) && shouldShowSizeError) {
    displayErrorMessage(true);
  }
};

const handleBopisPromotionCheck = (
  isBopisPromoDiscount,
  isBopisEnabled,
  isStoreSpecialsPricePresent
) => (isBopisPromoDiscount || isStoreSpecialsPricePresent) && isBopisEnabled;

// eslint-disable-next-line sonarjs/cognitive-complexity
const DeliveryButton = (props) => {
  const {
    heading,
    subheading,
    badge,
    isPickUpSelected,
    value,
    pickupSelectionUpdate,
    buttonSize,
    checkForOOSForVariant,
    isAllSizeDisabled,
    shippingMethodSelected,
    fulfillmentGroup,
    loading,
    isCartTile,
    eddData,
    isVariantsHasPreOrder,
    isShowShipToHomeEddEnabled,
    miscInfo,
    isPreOrderItemsIncluded,
    isBopisMultipleStoreEnabled,
    isBossMultipleStoreEnabled,
    shouldShowSizeError,
    displayErrorMessage,
    isPDP,
    isQuickView,
    shipments,
    freeShippingThershold,
    shippingTotal,
    isDynamicFreeShippingEnabled,
    orderType,
    productTotal,
    isBopisPromoDiscount,
    isBopisEnabled,
    setMethod,
    isStoreSpecialsPricePresent,
    freeShippingThreshold,
    freeShipsMsg,
    isFreeShippingOnFulfillmentTileEnabled,
  } = props;
  const { BOSS, HOME } = CARTPAGE_CONSTANTS;
  const isDisableButton = checkForOOSForVariant || isAllSizeDisabled || loading;
  const shippingId = shippingMethodSelected?.shippingMethodId;
  const isShipmentSelected =
    shippingId === '001' || shippingId === 'CGND_8' || shippingId === 'PGND_8';
  const isEddRendered =
    isShowShipToHomeEddEnabled && miscInfo && !miscInfo.preOrderDate && !isVariantsHasPreOrder;

  const ShipmentMethodTitle = (methodName) => (
    <BodyCopy
      fontFamily="secondary"
      fontWeight={getFontWeight(isPickUpSelected, checkForOOSForVariant, fulfillmentGroup)}
      textAlign="center"
      className={getClassName(subheading)}
    >
      {methodName}
    </BodyCopy>
  );
  const renderEddView = () => {
    const subTitleValue = checkForFreeShipping({
      isPDP,
      isQuickView,
      selectedShipmentCode: shippingMethodSelected?.code,
      shipments,
      freeShippingThershold,
      shippingTotal,
      isDynamicFreeShippingEnabled,
      orderType,
      productTotal,
    })
      ? subheading
      : '';
    return (
      <>
        {(value === BOSS?.toLowerCase() || !shippingMethodSelected) &&
          !(value === HOME && eddData) &&
          ShipmentMethodTitle(subTitleValue)}
        {value === HOME && eddData && !shippingMethodSelected && EddWrapper({ isPDP, isQuickView })}

        {shippingMethodSelected && value !== BOSS?.toLowerCase() && !isCanada()
          ? EddWrapper({
              isPDP,
              isQuickView,
              selectedShipmentCode: shippingMethodSelected?.code,
              subheading: shippingMethodSelected?.displayName,
              freeShippingThershold,
              shipments,
              shippingTotal,
              isDynamicFreeShippingEnabled,
              orderType,
              productTotal,
            })
          : ShipmentMethodTitle(
              isShipmentSelected ? subTitleValue : shippingMethodSelected?.displayName
            )}
      </>
    );
  };

  const renderNonEddView = () => {
    const subTitleValue = checkForFreeShipping({
      isPDP,
      isQuickView,
      selectedShipmentCode: shippingMethodSelected?.code,
      shipments,
      freeShippingThershold,
      shippingTotal,
      isDynamicFreeShippingEnabled,
      orderType,
      productTotal,
    })
      ? subheading
      : '';
    return (
      <>
        {(value === BOSS?.toLowerCase() || !shippingMethodSelected) &&
          ShipmentMethodTitle(subTitleValue)}
        {shippingMethodSelected &&
        value !== BOSS?.toLowerCase() &&
        !isCanada() &&
        !isPreOrderItemsIncluded
          ? EddWrapper({
              isPDP,
              isQuickView,
              selectedShipmentCode: shippingMethodSelected?.code,
              subheading: shippingMethodSelected?.displayName,
              freeShippingThershold,
              shipments,
              shippingTotal,
              isDynamicFreeShippingEnabled,
              orderType,
              productTotal,
            })
          : ShipmentMethodTitle(
              isShipmentSelected ? subTitleValue : shippingMethodSelected?.displayName
            )}
      </>
    );
  };

  useEffect(() => {
    if (setMethod) {
      setMethod((param) =>
        handleClick({
          param,
          isBopisMultipleStoreEnabled,
          isBossMultipleStoreEnabled,
          shouldShowSizeError,

          displayErrorMessage,
          isDisableButton,
          fulfillmentGroup,
          isPickUpSelected,
          value,
          pickupSelectionUpdate,
          fromStoreSpecial: true,
        })
      );
    }
  }, [
    setMethod,
    isBopisMultipleStoreEnabled,
    isBossMultipleStoreEnabled,
    shouldShowSizeError,
    displayErrorMessage,
    isPickUpSelected,
    isDisableButton,
    fulfillmentGroup,
    value,
    pickupSelectionUpdate,
  ]);

  return (
    <ClickTracker
      clickData={{
        customEvents: ['event113'],
        pickupOption: heading,
        isCartTile,
      }}
      className={`delivery-button ${isPickUpSelected && !isDisableButton ? 'selected' : ''}${
        isDisableButton ? ' disable-delivery-methods' : ''
      } ${value}  ${buttonSize} ${loading ? 'button-disable-overlay' : ''}`}
      onClick={() =>
        handleClick({
          isBopisMultipleStoreEnabled,
          isBossMultipleStoreEnabled,
          shouldShowSizeError,
          displayErrorMessage,
          isDisableButton,
          fulfillmentGroup,
          isPickUpSelected,
          value,
          pickupSelectionUpdate,
        })
      }
      // onClick={handleClick}
      onKeyDown={(e) => {
        if (fulfillmentGroup && isEnterKey(e)) {
          return isDisableButton || isPickUpSelected ? null : pickupSelectionUpdate(value);
        }
        return !isDisableButton && !isCartTile ? pickupSelectionUpdate(value) : null;
      }}
      role="button"
      tabIndex="0"
      dataLocator="delivery-button-comp"
    >
      <BodyCopy
        fontWeight="extrabold"
        fontFamily="secondary"
        component="span"
        className="header-pickup-line"
        textAlign="center"
      >
        {heading}
      </BodyCopy>

      {isEddRendered ? renderEddView() : renderNonEddView()}
      {/* {showEdd ? (
        EddWrapper(shippingMethodSelected, subheading, newBag)
      ) : (
        <BodyCopy
          fontFamily="secondary"
          fontWeight={`${
            (isPickUpSelected && !checkForOOSForVariant) || fulfillmentGroup
              ? 'extrabold'
              : 'regular'
          }`}
          textAlign="center"
          className={getClassName(subheading)}
        >
          {subheading}
        </BodyCopy>
      )} */}
      {badge ? (
        <div className="badge-container">
          <BodyCopy component="span" className="badge" fontWeight="bold">
            <PickupPromotionBanner bossBanner isPickupMobilePromotion />
          </BodyCopy>
        </div>
      ) : null}
      {handleBopisPromotionCheck(
        isBopisPromoDiscount,
        isBopisEnabled,
        isStoreSpecialsPricePresent
      ) ? (
        <div className="badge-container">
          <BodyCopy component="span" className="badge" fontWeight="bold">
            <BopisPromotionBanner
              isPickupMobilePromotion
              isStoreSpecialsPdP={isStoreSpecialsPricePresent && !isCartTile}
            />
          </BodyCopy>
        </div>
      ) : null}
      {renderFreeShippingMessage({
        value,
        freeShippingThreshold,
        isDynamicFreeShippingEnabled,
        freeShipsMsg,
        isFreeShippingOnFulfillmentTileEnabled,
      })}
      {fulfillmentGroup && <ButtonSpinner loading={loading} fill="black" />}
    </ClickTracker>
  );
};

DeliveryButton.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  badge: PropTypes.string,
  isPickUpSelected: PropTypes.bool,
  value: PropTypes.string,
  pickupSelectionUpdate: PropTypes.func,
  isAllSizeDisabled: PropTypes.bool,
  checkForOOSForVariant: PropTypes.bool,
  buttonSize: PropTypes.string.isRequired,
  itemBrand: PropTypes.string,
  loading: PropTypes.bool,
  fulfillmentGroup: PropTypes.bool,
  showEdd: PropTypes.bool,
  newBag: PropTypes.bool,
  isBopisPromoDiscount: PropTypes.bool,
  isBopisEnabled: PropTypes.bool,
};

DeliveryButton.defaultProps = {
  heading: '',
  itemBrand: '',
  subheading: '',
  badge: null,
  isPickUpSelected: false,
  value: 'home',
  pickupSelectionUpdate: () => {},
  isAllSizeDisabled: false,
  checkForOOSForVariant: false,
  loading: false,
  fulfillmentGroup: false,
  showEdd: false,
  newBag: false,
  isBopisPromoDiscount: false,
  isBopisEnabled: false,
};

export default withStyles(DeliveryButton, styles);
export { DeliveryButton as DeliveryButtonVanilla };
